import React from 'react'
//assets
import '../assets/css/Panel.css'
//Component
import PanelMonitor from './PanelMonitor'
import AddPanel from './AddPanel';
//material
import Settings from '@material-ui/icons/Settings'
import Delete from '@material-ui/icons/Delete'
import ImportExport from '@material-ui/icons/ImportExport'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit';

//store
import panels from '../store/panels';
import profile from '../store/profile'

//config
import config from '../config';
import axios from 'axios'
import { connect } from 'echarts';



class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: '',
      state: '1',  //默认选中第一个
      time: Number(600000), // 10分钟
      count: 0,
      getData: [],  // 请求的数据
      time1: "",
      time2: '',
    }
  }
  componentDidMount = () => {
  }

  editShow = () => {
    this.setState({
      show: ''
    })
  }
  removePanel = (id) => {
    panels.removePanel(this.props.panelName);
  }
  exportPropertyData = () => {
    return window.location.href = `${config.env.server}/iot/data/eventAPIKey/${this.props.eventAPIKey}/property/${this.props.property}/export`;
  }
  editPanel = () => {
    this.setState({
      show: 'edit'
    })
  }

  render() {
    const { eventName, property, panelId, tool, type } = this.props;
    const eventTitle = eventName.length > 20 ? eventName.substring(0, 20) + '...' : eventName;
    const dataSource = property.length > 20 ? property.substring(0, 20) : property;
    return (
      <div>
        <div className="Panel">
          <Tooltip title={eventName}>
            <div className='Panel__eventName'>{eventTitle}</div>
          </Tooltip>
          <Tooltip title={property}>
            <div className='Panel__datasource'>數據源:{dataSource}</div>
          </Tooltip>
          <div className="Panel__monitor" >
            <PanelMonitor width='100%' height='100%' panelId={panelId} data={this.props.data} type={this.props.type} tool={this.props.tool} property={this.props.property} widget={this.props.widget} eventName={this.props.eventName} />
          </div>
          <div className="Panel__export" onClick={this.exportPropertyData}>
            <Tooltip title='Export Data'>
              <div>
                <ImportExport style={{ fontSize: 20 }} />
                <span style={{ fontSize: 10, position: 'relative', top: '-5px' }}>導出數據</span>
              </div>
            </Tooltip>
          </div>
          <div className="Panel_edit" onClick={this.editPanel}>
            <Tooltip title='Edit data'>
              <div>
                <EditIcon style={{ fontSize: 16 }} />
                <span style={{ fontSize: 10, position: 'relative', top: '-5px' }}>編輯</span>
              </div>
            </Tooltip>
          </div>
          <div className="Panel__delete" onClick={this.removePanel}>
            <Tooltip title='Remove Panel' >
              <div>
                <Delete style={{ fontSize: 18 }} />
                <span style={{ fontSize: 10, position: 'relative', top: '-4px' }}>删除</span>
              </div>
            </Tooltip>
          </div>
        </div>
        {this.state.show === 'edit' ? <AddPanel show={'edit'} data={this.props} editShow={this.editShow} /> : ''}
      </div>
    )
  }
}

export default Panel;


// WEBPACK FOOTER //
// ./src/components/Panel.js